export const INACTIVITY_TIMEOUT_MS = 2 * 60 * 60 * 1000;
export const STORAGE_KEY = 'last_user_activity_timestamp';
export const CHANNEL_NAME = 'app_session_inactivity_channel';
